export const analysis = {
    labels: {
        elapsed_time: "Tempo decorrido",
        risk_degree: "Grau de Risco",
        analysis_status: "Status da Análise",
        analysis_data: "Dados da Análise",
        cancellation_reason: "Motivo do cancelamento",
        form_questions: "Perguntas do Formulário",
        method_questions: "Perguntas do Método",
        breaks: "Pausas da Análise",
        add_pause: "Adicionar Pausa",
        date_edit: "Editar Data",
        remove_pause: "Retomar",
        motive: "Motivo",
    },
    placeholder: {
        motive: "Informe o Motivo",
    },
    modal: {
        title: {
            resume: "Retomar Análise",
        },
        message: {
            resume: "Você deseja RETOMAR a análise?<br>Essa operação não poderá ser desfeita!"
        },
    },
    toast: {
        error: {
            require_fields: "Preencha os campos obrigatórios",
            required_motive: "O campo MOTIVO é obrigatório",
        },
    },
    texts: {
        cancel_analysis: "Deseja <strong>CANCELAR</strong> esta Análise?<br>Essa operação não poderá ser desfeita!",
        finish_analysis: "Deseja <strong>FINALIZAR</strong> testa Análise?<br>Essa operação não poderá ser desfeita!",
        start_analysis: "Deseja <strong>INICIAR</strong> esta Análise?<br>Essa operação não poderá ser desfeita!",
        pause_analysis: "Deseja adicionar uma <strong>PAUSA</strong> nesta Análise?<br>Essa operação não poderá ser desfeita!",
        resume_analysis: "Deseja <strong>RETOMAR</strong> esta Análise?",
        empty_questions: "Você não possui PERGUNTAS para esta Análise!",
        empty_form: "Você não adicionou um FORMULÁRIO na Análise!",
        empty_employee: "Você não adicionou um FUNCIONÁRIO na Análise!",
        empty_sample: "Você não adicionou uma AMOSTRA na Análise!",
        empty_method: "Você não adicionou um MÉTODO na Análise!",
        empty_equipment: "Você não adicionou um EQUIPAMENTO na Análise!",
        empty_signature: "Você não adicionou uma ASSINATURA na Análise!",
        empty_break: "Você não adicionou PAUSAS nesta análise!",
    },
};
